import {
    FETCH_WEBHOOKS,
    FETCH_WEBHOOKS_FAILURE,
    FETCH_WEBHOOKS_SUCCESS,

    FETCH_WEBHOOK,
    FETCH_WEBHOOK_FAILURE,
    FETCH_WEBHOOK_SUCCESS,
} from 'store/actions/types';

export const fetchWebhooks = (payload) => {

    const params = {
        size: payload.size || 24,
        sort_by: payload.field || 'name',
        sort_direction: payload.order || 'asc',
    };

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    return {
        type: FETCH_WEBHOOKS,
        payload: params,
    };
};

export const fetchWebhooksFailure = (error) => {
    return {
        type: FETCH_WEBHOOKS_FAILURE,
        error: error,
    };
};

export const fetchWebhooksSuccess = (payload) => {
    return {
        type: FETCH_WEBHOOKS_SUCCESS,
        payload: payload,
    };
};

export const fetchWebhook = (payload) => {
    return {
        type: FETCH_WEBHOOK,
        payload: payload,
    };
};

export const fetchWebhookFailure = (error) => {
    return {
        type: FETCH_WEBHOOK_FAILURE,
        error: error,
    };
};

export const fetchWebhookSuccess = (payload) => {
    return {
        type: FETCH_WEBHOOK_SUCCESS,
        payload: payload,
    };
};

export const updateListParams = (payload) => {
    return {
        type: payload.type,
        payload: payload.payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/webhooks/fetchWebhooks.js